import { cn } from '@/lib/utils'

type ButtonVariant = 'primary' | 'accent' | 'light' | 'outline' | 'outline-light'

type ButtonSize = 'sm' | 'md' | 'lg'

const base = 'inline-flex items-center justify-center gap-2 rounded-lg font-semibold whitespace-nowrap transition-[color,background-color,border-color,box-shadow] focus-visible:outline-none focus-visible:ring-4 disabled:pointer-events-none disabled:opacity-60'

const variants: Record<ButtonVariant, string> = {
    primary: 'bg-primary text-primary-foreground shadow-lg shadow-primary/25 hover:bg-primary/90 focus-visible:ring-primary/30',
    accent: 'bg-teal text-ink shadow-lg shadow-teal/20 hover:bg-teal/90 focus-visible:ring-teal/40',
    light: 'bg-white text-ink hover:bg-white/90 focus-visible:ring-white/30',
    outline: 'border border-border bg-white text-foreground hover:border-primary/40 hover:bg-secondary focus-visible:ring-primary/20',
    'outline-light': 'border border-white/20 text-white hover:border-white/35 hover:bg-white/10 focus-visible:ring-white/25'
}

const sizes: Record<ButtonSize, string> = {
    sm: 'h-10 px-4 text-sm',
    md: 'h-11 px-5 text-sm',
    lg: 'h-12 px-6 text-[15px]'
}

export const buttonClass = (variant: ButtonVariant = 'primary', size: ButtonSize = 'md', className?: string): string => cn(base, variants[variant], sizes[size], className)
